import * as React from "react"
import PropTypes from "prop-types"

import HeaderWrapper from "components/Header/HeaderWrapper"
import HeaderContainer from "components/Header/HeaderContainer"
import HeaderLogo from "components/Header/HeaderLogo"
import HeaderNavList from "components/Header/HeaderNavList"
import HeaderButton from "components/Header/HeaderButton"
import HeaderNavItem from "components/Header/HeaderNavItem"
import HeaderNavWrapper from "components/Header/HeaderNavWrapper"
import HeaderBtnToggle from "components/Header/HeaderBtnToggler"

import useScrollPosition from "../hooks/useScrollPosition"

const Header = ({ baseUrl, logo, navigation, buttonTitle, buttonLink, hasScroll, scrollLogo }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [isHovered, setIsHovered] = React.useState(false)
  const handleClick = () => setIsOpen(!isOpen)

  const isScrolled = useScrollPosition(58)

  const getLogo = () => {
    if (!hasScroll) {
      return logo
    }

    if (isHovered || isScrolled) {
      return logo
    }

    return scrollLogo
  }

  const logoToShow = getLogo()

  React.useEffect(() => {
    if (isOpen) {
      document.querySelector("#gatsby-focus-wrapper").style.overflow = "hidden"
    } else {
      document.querySelector("#gatsby-focus-wrapper").style.overflow = ""
    }
  }, [isOpen])

  return (
    <HeaderWrapper
      hasScroll={hasScroll}
      isScrolled={isScrolled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <HeaderContainer>
        <HeaderLogo image={logoToShow} link={baseUrl} />
        <HeaderBtnToggle handleClick={handleClick} />
        <HeaderNavWrapper isOpen={isOpen}>
          <HeaderNavList>
            {navigation?.map(({ id, ...props }) => (
              <HeaderNavItem
                isHovered={isHovered}
                hasScroll={hasScroll}
                isScrolled={isScrolled}
                handleClose={setIsOpen}
                key={id}
                {...props}
              />
            ))}
          </HeaderNavList>
          <HeaderButton
            title={buttonTitle}
            isHovered={isHovered}
            link={buttonLink}
            hasScroll={hasScroll}
            isScrolled={isScrolled}
          />
        </HeaderNavWrapper>
      </HeaderContainer>
    </HeaderWrapper>
  )
}

Header.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  logo: PropTypes.object.isRequired,
  scrollLogo: PropTypes.object.isRequired,
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      modelName: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      link: PropTypes.string,
      hasAbsolute: PropTypes.bool,
      subItems: PropTypes.array,
    }),
  ).isRequired,
  buttonTitle: PropTypes.string.isRequired,
  buttonLink: PropTypes.string.isRequired,
  hasScroll: PropTypes.bool.isRequired,
}

export default Header
